<template>
  <div class="invoiceItemList">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="$t.invoiceItemList.searchText"
          >
            <template #action>
              <div @click="onSearch">{{ $t.meta.search }}</div>
            </template>
          </van-search>
        </van-col>
      </van-row>
    </div>

    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :finished-text="$t.meta.noMore"
      :error.sync="error"
      :error-text="errorText"
      @load="getList(page + 1)"
    >
      <div class="list-container" v-for="(item, index) in tableData" :key="index">
        <div class="list-item">
          {{ $t.invoiceItemList.itemName }}：{{ item.ItemName }}
        </div>
        <div class="list-item">
          {{ $t.invoiceItemList.itemNameEn }}：{{ item.ItemNameEn }}
        </div>
        <div class="buttons">
          <van-button
            class="primary-btn"
            size="small"
            type="primary"
            @click="gotoDetail(item.ItemId)"
            >{{ $t.meta.editButton }}</van-button
          >

          <van-button
            class="danger-btn"
            size="small"
            type="primary"
            @click="deleteInvoiceItem(item.ItemId)"
          >
            {{ $t.meta.delete }}
          </van-button>
        </div>
      </div>
    </van-list>

    <div class="tool-bar">
      <van-button type="info" block @click="gotoDetail(null)">{{
        $t.invoiceItemList.addButton
      }}</van-button>
    </div>
  </div>
</template>

<script>
import { List, Row, Col, Search, Button, Form, Field } from "vant";

import Vue from "vue";
Vue.use(List).use(Row).use(Col).use(Search).use(Button).use(Form).use(Field);

export default {
  name: "invoiceItemList",
  data() {
    return {
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      tableData: [],
      page: 0,
      pageSize: 10,
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //filter
      searchText: "",
      //日期
      currentDate: "",
      showStartPicker: false,
      beginTime: "",
      showEndPicker: false,
      endTime: "",
    };
  },
  created() {},
  methods: {
    gotoDetail(id) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "invoiceItemListDetail",
        name: "invoiceItemListDetail",
        query: [
          {
            name: "ItemId",
            value: id,
          },
          {
            name: "IsEdit",
            value: id ? true : false,
          },
        ],
      });
    },
    onSearch() {
      this.initList();
      this.getList(1);
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.tableData = [];
    },
    deleteInvoiceItem(id) {
      this.$commonMethod.showLoading();
      var param = {
        CompanyId: this.CompanyId,
        ItemIdList: [id],
      };
      this.$api.financialManagement
        .deleteInvoiceItem(param)
        .then(() => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.operateSuccess,
            type: "success",
          });
          this.initList();
          this.getList(1);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    getList(page) {
      var param = {
        PageIndex: page,
        PageSize: this.pageSize,
        CompanyId: this.CompanyId,
        UserId: this.UserId,
        ItemName: this.searchText,
        BeginTime: this.beginTime,
        EndTime: this.endTime,
      };
      this.$api.financialManagement
        .getInvoiceItemList(param)
        .then((res) => {
          this.tableData = this.tableData.concat(res.data.Data);
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.page = res.meta.page;
          this.finished = this.page >= res.meta.lastPage;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.invoiceItemList {
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    border-bottom: 1px solid #ebedf0;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 100%;
        text-align: center;
        font-size: 14px;
        .van-search__action {
          width: 15%;
        }
        .van-search__content {
          padding: 0px;
          .van-cell {
            padding: 5px 8px 5px 8px;
          }
        }
      }
    }
  }
  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      .list-item {
        margin-bottom: 10px;
      }
      .buttons {
        text-align: right;
        .primary-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-primary;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .default-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-light-gray;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .search-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-green;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .danger-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-red;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
